import TextField from '@mui/material/TextField';
import Skeleton from '@mui/material/Skeleton';
import { Typography } from '@mui/material';

const PageReadOnlyInputCopy = ({ tag, value, width, font, isLoading=false}) =>{
    // set width if not given as prop
    if (width == null){
        width = '16.6vw';
    } 
    // set font size if given as prop, else use default
    let style = {'fontFamily':"Roboto medium, Helvetica, Arial, sans-serif"};
    if (font){
        style['fontSize'] = font;
    }
    return (
        <>
            { isLoading ? 
            <>
                <Skeleton variant="rectangular" width='100%' height={'40px'} sx={{ borderRadius: '5px' }}/>
            </>
            : 
            /* material ui textfield for uneditable text display */
            <div className={"d-flex width-fit-content align-items-center gap-3"}>
                <Typography fontSize={"14px"} className='align-self-center lh-24'>{tag}</Typography>
                <TextField 
                    id="outlined-basic" 
                    sx={{ width: width, maxWidth: 450 }}
                    size='small' 
                    variant="outlined" 
                    value={value !== (null || "") ? value : "None"} 
                    disabled
                    inputProps={{style: style, readOnly: true}} // font size of input text
                    InputLabelProps={{style: style}} // font size of input label
                />
            </div>} 
        </>
    );
}

export default PageReadOnlyInputCopy;